var _rect, _rect2, _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRestoreIconHover = function SvgRestoreIconHover(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 28.5,
    height: 28.5,
    rx: 14.25,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 28.5,
    height: 28.5,
    rx: 14.25,
    stroke: "#A0A0A0",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7363 13.1416V23.4166C10.7363 23.8525 10.8782 24.2257 11.162 24.5361C11.4457 24.8465 11.7868 25.0017 12.1853 25.0017H19.43C19.8284 25.0017 20.1695 24.8465 20.4533 24.5361C20.737 24.2257 20.8789 23.8525 20.8789 23.4166V13.1416H19.43V23.4166H12.1853V13.1416H10.7363ZM21.6023 13.113H21.6034V11.5278H21.6023V13.113ZM15.0831 21.8314H13.6342V14.6982H15.0831V21.8314ZM17.981 21.8314H16.5321V14.6982H17.981V21.8314Z",
    fill: "#A0A0A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4313 12.6134L23.1674 11.2732L19.9925 9.52933L20.3741 8.83464L16.5641 6.74196L16.1826 7.43665L13.0076 5.69275L12.2445 7.08213L12.2459 7.08291L12.2729 7.03371L22.4313 12.6134Z",
    fill: "#A0A0A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3761 11.8872C14.1 11.4817 13.755 11.1261 13.3409 10.8204C12.5643 10.2472 11.6863 9.95522 10.707 9.94455C10.1117 9.93806 9.54247 10.0428 8.99932 10.2589C8.45618 10.4749 7.97115 10.7863 7.54425 11.193L7.55835 9.8989L6.48481 9.88721L6.45117 12.975L9.56742 13.0089L9.579 11.9452L8.34344 11.9317C8.66439 11.6295 9.02743 11.3988 9.43256 11.2398C9.83768 11.0807 10.2606 11.0035 10.7012 11.0083C11.3784 11.0157 11.996 11.204 12.5541 11.5733C12.6994 11.6695 12.8349 11.7741 12.9606 11.8872H14.3761Z",
    fill: "#A0A0A0"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRestoreIconHover, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/restore-icon-hover.378749e0.svg";
export { ForwardRef as ReactComponent };